module.exports = __webpack_public_path__ + "media/images/team/john_mcneely-f783d74c6d92bc03c9f46d3a4a4853c2.png";